export const imagePaths = {
  heroMobile: "/wed_pin1.png",
  heroDesktop: "/heroDesktop.jpg",
  heroMobilePosition: "center bottom",
  heroTextPosition: "45%",
  couple: "/images/couple-image.jpg",
  venue: "/images/venue-image.jpg",
  background: "/background.jpg",
  backgroundBlur: "0px"
};

